/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['./Sunburst'], function(Sunburst) {
	'use strict';
	class Decisiontree extends Sunburst {
		constructor(){
			super();
		}

		get config(){
			const config = super.config;
			config.type = 'DecisionTree';
			config.useFPDAsInsightsInput =  true; /*Use Fast Predict Key driver response as chart insights request input*/
			config.tabs.default = 'showTree';

			config.properties.actions.defaultValue = 'showTree';

			[
				'legend.display',
				'legendPosition',
				'showMinimap'
			].forEach(property => delete config.properties[property]);

			return config;
		}

	}
	return Decisiontree;
});